import { GQL_OfferStatus } from "sharedTypes/offers/offers";

export const offerMapper = (offer: any) => {
  let _offer: any = {}
  if(offer) {
    _offer = {...offer}
    Object.keys(offer).forEach((key) => {
      switch(key) {
      case 'emptyCity' : {
        _offer.emptyCity = offer.emptyCity?.name;
        _offer.emptyCityIANACode = offer.emptyCity?.timeZone?.ianaName;
        if(offer.emptyCity?.id) {
          _offer.emptyCityLocation = {
            CityName: offer.emptyCity.name,
            CityState: offer.emptyCity.state.code,
            CountryId: offer.emptyCity.country.id,
            Geolocation: offer.emptyCity.geocode,
            Id: offer.emptyCity.id,
            Name: `${offer.emptyCity.name}, ${offer.emptyCity.state.code}`.toLocaleUpperCase(),
            Value: `CITY_${offer.emptyCity.id}`,
            Zone: offer.emptyCity.zone
          }
        }
      }
        break;
      case 'status' :
        _offer.status = GQL_OfferStatus[offer?.status] as any;
        break;
      case 'updates':
        _offer.timerStart = offer.updates[0].timerStart;
        _offer.expiration = offer.updates[0].timerEnd;
        delete _offer.updates;
        break;
      case 'updatesCount':
        _offer.updateCount = offer.updatesCount;
        delete _offer.updatesCount;
        break;
      case 'load':
        _offer.loadNumber = offer.load.id;
        if(offer.load?.stops?.length){
          _offer.originCity = offer.load.stops[0].facility.city;
          _offer.originState = offer.load.stops[0].facility.stateCode;
          _offer.originEarliest = offer.load.stops[0].earliest;
          _offer.originLatest = offer.load.stops[0].latest;
          _offer.originCityIANATimeZoneName = offer.load.stops[0].facility.timeZone.ianaName;
          _offer.originGeocode = offer.load.stops[0].facility.geolocation;
          const lastStop = offer.load.stops.length - 1;
          _offer.destinationCity = offer.load.stops[lastStop].facility.city;
          _offer.destinationState = offer.load.stops[lastStop].facility.stateCode;
          _offer.destinationEarliest = offer.load.stops[lastStop].earliest;
          _offer.destinationLatest = offer.load.stops[lastStop].latest;
          _offer.destinationCityIANATimeZoneName = offer.load.stops[lastStop].facility.timeZone.ianaName;
          _offer.destinationGeocode = offer.load.stops[lastStop].facility.geolocation;
        }
        delete _offer.load;
        break;
      default: { //no op
      }
      }
    })

  }
  return _offer
}

